"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncContext = void 0;
const AsyncVariable_1 = require("./AsyncVariable");
const AsyncSnapshot_1 = require("./AsyncSnapshot");
class AsyncContext {
}
exports.AsyncContext = AsyncContext;
AsyncContext.Variable = AsyncVariable_1.AsyncVariable;
AsyncContext.Snapshot = AsyncSnapshot_1.AsyncSnapshot;
//# sourceMappingURL=AsyncContext.js.map